import {ChevronRight} from 'lucide-react'
import {cn} from '@/lib/utils'

type ChevronLinkProps = {
  children: React.ReactNode
  className?: string
  /** When true, the chevron animates on parent .group hover (e.g. card hover) */
  groupHover?: boolean
}

/**
 * Inline text with a chevron icon that translates right on hover.
 * Chevron size and gap scale with the text via em units.
 */
export function ChevronLink({children, className, groupHover = false}: ChevronLinkProps) {
  return (
    <span className={cn('group/chevron inline-flex items-center', className)}>
      {children}
      <ChevronRight
        className={cn(
          'size-[0.9em] transition-transform duration-200',
          groupHover
            ? 'group-hover:translate-x-[0.15em]'
            : 'group-hover/chevron:translate-x-[0.15em]',
        )}
      />
    </span>
  )
}
